<template lang="pug">
div
  .modal.is-active(v-if="isDialogDesactivarFeriado")
    .modal-background(@click="closeDialogDesactivarFeriado()")
    .card.width-350
      header.card-header
        p.card-header-title
          span Desactivar feriado
      .card-content
        .content
          template
            span.bold ¿Realmente deseas desactivar el dia festivo
            strong.bold.has-text-primary  &nbsp; {{nuevoFeriado.nombre}}  &nbsp;
            span ?
      footer.card-footer
        button.button.card-footer-item.is-outlined.info-box-button(@click="closeDialogDesactivarFeriado()", :disabled="isLoading") Cancelar
        button.button.card-footer-item.is-danger.info-box-button(@click="fetchDesactivarFeriado()", :disabled="isLoading", :class="{ 'is-loading' : isLoading }")
          span Desactivar
  .modal.is-active(v-if="isDialogActivarFeriado")
    .modal-background(@click="closeDialogActivarFeriado()")
    .card.width-350
      header.card-header
        p.card-header-title
          span Activar feriado
      .card-content
        .content
          template
            span.bold ¿Realmente deseas activar el dia festivo
            strong.bold.has-text-primary  &nbsp; {{nuevoFeriado.nombre}}  &nbsp;
            span ?
      footer.card-footer
        button.button.card-footer-item.is-outlined.info-box-button(@click="closeDialogActivarFeriado()", :disabled="isLoading") Cancelar
        button.button.card-footer-item.is-success.info-box-button(@click="fetchActivarFeriado()", :disabled="isLoading", :class="{ 'is-loading' : isLoading }")
          span Activar
  .modal.is-active(v-if="isDialogResetearFeriado")
    .modal-background(@click="closeDialogResetearFeriado()")
    .card.width-350
      header.card-header
        p.card-header-title
          span Resetear feriados
      .card-content
        .content
          template
            strong.bold ¿Realmente deseas resetear los dias festivos?
            strong.has-text-danger Este proceso eliminará los feriados registrados por el usuario y dejará solo los feriados por defecto para el periodo {{periodo}}
      footer.card-footer
        button.button.card-footer-item.is-outlined.info-box-button(@click="closeDialogResetearFeriado()", :disabled="isLoading") Cancelar
        button.button.card-footer-item.is-primary.info-box-button(@click="fetchResetear()", :disabled="isLoading", :class="{ 'is-loading' : isLoading }")
          span Resetear
  .modal.is-active(v-if="showModalAdd")
    .modal-background(@click="closeModalAdd")
    .card.w-350
      header.card-header
        p.card-header-title
          span {{ nuevoFeriado.id ? 'Editar' : 'Nuevo'}}  dia festivo
      .card-content
        .content.d-flex.fd-column
          .flex-1.margin-bottom-20
            label.label.is-small.has-text-left Fecha
            .control.has-icons-left
              input.input.is-small(
                type="date"
                v-model='nuevoFeriado.fecha',
                :disabled='isLoading')
              span.icon.is-small.is-left
                i.fa.fa-check-circle
          .flex-1.margin-bottom-20
            label.label.is-small.has-text-left Descripcion del dia festivo
            .control.has-icons-left
              textarea.textarea.input.is-small(
                rows="2"
                v-model='nuevoFeriado.nombre',
                :disabled='isLoading')
              span.icon.is-small.is-left
                i.fa.fa-check-circle

          .flex-1.d-flex.justify-content-flex-end.margin-top-20px
            p.control
              button.button.is-small.is-light(:disabled='isLoading', @click='closeModalAdd()')
                span.icon.is-small
                span Cancelar
            p.control.control.margin-left-5
              button.button.is-small.is-success(:disabled='isLoading', @click='fetchGuardar()')
                span.icon.is-small
                  i.fa.fa-save
                span Guardar cambios
  .card
    .card-content
      .d-flex.align-items-center
        .flex.d-flex.jc-center.fd-column
          label.label.is-small.has-text-left Periodo
          .select.is-small
            select.select-width(:disabled='isLoading', v-model='periodo' @change='fetch()')
              option(:value='p' v-for="(p, index) in periodos" :key="index") {{ p }}

        .flex-1.d-flex.justify-content-flex-end
          p.control.margin-left-5
            button.button.is-small.is-success(:disabled='isLoading', @click='openModalAdd()')
              span.icon.is-small
                i.fa.fa-plus
              span Nuevo feriado
          p.control.control.margin-left-5
            button.button.is-small(:disabled='isLoading', @click='openDialogResetearFeriado()')
              span.icon.is-small
                i.fa.fa-refresh
              span Resetear feriados
          p.control.control.margin-left-5
            button.button.is-small.is-primary(:disabled='isLoading', @click='fetch()')
              span.icon.is-small
                i.fa.fa-refresh
              span Actualizar
  .card.margin-top-5
    .position-relative.data-table-full
      .empty-list(v-if="!lista.length && !isLoading")
        i.fa.fa-address-card.fa-6x
        .info-message
          span No se encuentran registros para esta búsqueda
      table.table.table.is-full-width.is-responsive(v-if="lista.length")
        thead
          tr
            th.center-vertical-align-middle.cursor-pointer #
            th.center-vertical-align-middle.cursor-pointer Registrado
            th.center-vertical-align-middle.cursor-pointer Estado
            th.center-vertical-align-middle.cursor-pointer Fecha
            th.center-vertical-align-middle.cursor-pointer Descripcion
            th.center-vertical-align-middle.cursor-pointer Accion
        tbody(name="fade-smooth",
              tag="tbody" v-show='lista.length !== 0',
            )
          tr( v-for='(item, index) in lista',
            :class="{'bd-desactivado' : !item.activo}"
            :key="`index_${index + 1}`"
          )
            td.center-vertical-align-middle.cursor-pointer
              span {{index + 1}}
            td.center-vertical-align-middle.cursor-pointer
              span  El &nbsp;
              span {{item.fechaCreacion | formatoFecha}}
              span  por &nbsp;
              strong {{item.nombreUsuarioCreador}} &nbsp;
            td.center-vertical-align-middle.has-text-centered
              strong.chip.tag(:class="{ 'is-success' : item.activo, 'is-danger' : !item.activo }") {{item.activo ? 'Activo' : 'Inactivo'}}
            td.center-vertical-align-middle.has-text-centered
              strong.has-text-info {{item.fecha | formatoFechaText}}
            td.center-vertical-align-middle
              strong {{item.nombre}}
            td.center-vertical-align-middle.has-text-centered
              button.button.is-small.margin-left-5(
                :disabled='isLoading || !item.activo',
                @click='editarForm(item)'
              )
                span.icon.is-small
                  i.fa.fa-pencil-square-o
                span Editar
              button.button.is-small.is-danger.margin-left-5(
                :disabled='isLoading',
                v-if="item.activo",
                @click='openDialogDesactivarFeriado(item)'
              )
                span Desactivar
              button.button.is-small.is-success.margin-left-5(
                :disabled='isLoading',
                v-else
                @click='openDialogActivarFeriado(item)'
              )
                span &nbsp; Activar &nbsp;&nbsp;
      loading-global-sil(v-if="isLoading" :message="'Cargando'")
</template>
<script>
import moment from 'moment';
import cargandoLoad                             from '../components/Component_Cargando'
import { apiGet, apiPost, notify }          from '../util/general.js'
import { mixin as clickaway }                   from 'vue-clickaway';
export default {
  components : {
    'loading-global-sil': cargandoLoad
  },
  mixins: [ clickaway ],
  data () {
    return {
      perfil                : localStorage.getItem('perfil'),
      isloading             : false,
      showModalAdd          : false,
      isDialogActivarFeriado          : false,
      isDialogResetearFeriado          : false,
      lista                 : [],
      isDialogDesactivarFeriado          : false,
      periodos : ['2026', '2027', '2028'],
      periodo : moment().format('YYYY'),
      nuevoFeriado : {
        id: 0,
        fecha: new Date(),
        nombre: '',
        activo: true
      }
    }
  },
  created () {
    var vm = this
    vm.setearPeriodos()
    vm.fetch()
  },
  filters: {
    formatoFecha (fecha) {
      return moment(fecha).format('DD/MM/YYYY')
    },
    formatoFechaText (fecha) {
      return moment(fecha).locale('es').format('LL')
    }
  },
  methods: {
    setearPeriodos () {
      var vm              = this
      vm.periodos = []
      var anioActual = moment().year()
      for (var i = anioActual - 1; i <= anioActual + 1; i++) {
        vm.periodos.push(i.toString())
      }
    },
    openDialogResetearFeriado () {
      var vm              = this
      vm.isDialogResetearFeriado = true
    },
    closeDialogResetearFeriado () {
      var vm              = this
      vm.isDialogResetearFeriado = false
    },
    closeModalAdd () {
      var vm              = this
      vm.showModalAdd = false
    },
    openDialogDesactivarFeriado (item) {
      var vm              = this
      vm.nuevoFeriado.id  = item.id
      vm.nuevoFeriado.fecha = moment(item.fecha).format('YYYY-MM-DD')
      vm.nuevoFeriado.nombre = item.nombre
      vm.nuevoFeriado.activo = item.activo
      vm.isDialogDesactivarFeriado = true
    },
    openDialogActivarFeriado (item) {
      var vm              = this
      vm.nuevoFeriado.id  = item.id
      vm.nuevoFeriado.fecha = moment(item.fecha).format('YYYY-MM-DD')
      vm.nuevoFeriado.nombre = item.nombre
      vm.nuevoFeriado.activo = item.activo
      vm.isDialogActivarFeriado = true
    },
    closeDialogDesactivarFeriado () {
      var vm              = this
      vm.nuevoFeriado.id  = 0
      vm.nuevoFeriado.fecha = moment().format('YYYY-MM-DD')
      vm.nuevoFeriado.nombre = ''
      vm.nuevoFeriado.activo = false
      vm.isDialogDesactivarFeriado = false
    },
    closeDialogActivarFeriado () {
      var vm              = this
      vm.nuevoFeriado.id  = 0
      vm.nuevoFeriado.fecha = moment().format('YYYY-MM-DD')
      vm.nuevoFeriado.nombre = ''
      vm.nuevoFeriado.activo = false
      vm.isDialogActivarFeriado = false
    },
    openModalAdd () {
      var vm     = this
      vm.nuevoFeriado.id  = 0
      vm.nuevoFeriado.fecha = moment().format('YYYY-MM-DD')
      vm.nuevoFeriado.nombre = ''
      vm.nuevoFeriado.activo = true
      vm.showModalAdd = true
    },
    fetch () {
      var vm                         = this
      vm.lista = []
      vm.isLoading         = true
      var url         = `/dias-festivos/obtener/${vm.periodo}`
      var obj = {
        octopus     : true,
        activo      : 'all'
      }
      apiGet(vm, url, obj, function (data) {
        vm.lista = data.data
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isLoading = false
      })
    },
    fetchGuardar () {
      var vm  = this
      if (!vm.nuevoFeriado.fecha) {
        notify(vm, 'error', 'Error', 'El campo Fecha es obligatorio.')
        return
      }

      if (!vm.nuevoFeriado.nombre) {
        notify(vm, 'error', 'Error', 'El campo Descripción es obligatorio.')
        return
      }

      var url = '/dias-festivos/agregar'
      var obj = {
        form: vm.nuevoFeriado,
        octopus       : true
      }
      apiPost(vm, url, obj, function (data) {
        notify(vm, 'success', 'Exito', 'Los cambios se han guardado correctamente.')
        vm.fetch()
        vm.closeModalAdd()
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isLoading = false
      })
    },
    fetchDesactivarFeriado () {
      var vm  = this
      var url = '/dias-festivos/desactivar'
      var obj = {
        form: vm.nuevoFeriado,
        octopus       : true
      }
      apiPost(vm, url, obj, function (data) {
        notify(vm, 'success', 'Exito', 'Los cambios se han guardado correctamente.')
        vm.fetch()
        vm.closeDialogDesactivarFeriado()
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      })
    },
    fetchActivarFeriado () {
      var vm  = this
      var url = '/dias-festivos/activar'
      var obj = {
        form: vm.nuevoFeriado,
        octopus       : true
      }
      apiPost(vm, url, obj, function (data) {
        notify(vm, 'success', 'Exito', 'Los cambios se han guardado correctamente.')
        vm.fetch()
        vm.closeDialogActivarFeriado()
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      })
    },
    fetchResetear () {
      var vm  = this
      var url = '/dias-festivos/resetear'
      var obj = {
        periodo: vm.periodo,
        octopus       : true
      }
      apiPost(vm, url, obj, function (data) {
        notify(vm, 'success', 'Exito', 'Proceso de reseteo se ha ejecutado correctamente.')
        vm.fetch()
        vm.closeDialogResetearFeriado()
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      })
    },
    editarForm (item) {
      var vm              = this
      vm.nuevoFeriado.id  = item.id
      vm.nuevoFeriado.fecha = moment(item.fecha).format('YYYY-MM-DD')
      vm.nuevoFeriado.nombre = item.nombre
      vm.nuevoFeriado.activo = item.activo
      vm.showModalAdd          = true
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "../assets/colors.styl"
.w-350
  width: 350px;
.data-table
  max-height: calc(100vh - 180px);
  min-height: calc(100vh - 180px);
  overflow-y: scroll;
  overflow-x: hidden;
  border-top: 1px solid #d0d4da;

.data-table-full
  max-height: calc(100vh - 180px);
  min-height: calc(100vh - 180px);
  overflow-y: scroll;
  overflow-x: hidden;
  border-top: 1px solid #d0d4da;

table
  font-size: 11px !important

table
  font-size: 11px !important
.width-350
  width: 350px;

.d-flex
  display flex

.bd-desactivado
  background-color: #ff386017 !important

.select-width
  width: 100px

.fd-column
  flex-direction column

.flex-1
  flex 1

.justify-content-flex-end
  justify-content flex-end

.margin-bottom-20
  margin-bottom 20px
</style>




// WEBPACK FOOTER //
// View_Dias_Festivos.vue?1c3dbe5f